import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

let redirectingToOAuthCallback = false;
const preloadReloadGuardKey = 'vite:preload:reloaded';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    // Prevent runtime crash when a hashed chunk was rotated by a new deploy.
    event.preventDefault();
    const hasReloaded = window.sessionStorage.getItem(preloadReloadGuardKey) === '1';
    if (hasReloaded) {
      window.sessionStorage.removeItem(preloadReloadGuardKey);
      return;
    }
    window.sessionStorage.setItem(preloadReloadGuardKey, '1');
    window.location.reload();
  });
}

if (typeof window !== 'undefined') {
  const currentUrl = new URL(window.location.href);
  const hasOAuthCode = currentUrl.searchParams.has('code');
  const isInFunctionCallback = currentUrl.pathname.startsWith('/functions/oauth-callback');

  // Prevent showing ?code=... in the app route by redirecting to the edge callback
  // before React mounts. This keeps the existing auth logic intact.
  if (hasOAuthCode && !isInFunctionCallback) {
    redirectingToOAuthCallback = true;
    const cleanNext = new URL(currentUrl.origin + currentUrl.pathname);
    const nextSearch = new URLSearchParams(currentUrl.search);
    nextSearch.delete('code');
    nextSearch.delete('state');
    if (nextSearch.toString()) {
      cleanNext.search = nextSearch.toString();
    }

    const callbackUrl = new URL(`${currentUrl.origin}/functions/oauth-callback`);
    callbackUrl.searchParams.set('code', currentUrl.searchParams.get('code') || '');
    callbackUrl.searchParams.set('next', cleanNext.toString());
    window.location.replace(callbackUrl.toString());
  }
}

const shouldLoadAhrefsAnalytics =
  import.meta.env.PROD ||
  (import.meta as ImportMeta).env?.VITE_ENABLE_AHREFS_ANALYTICS === 'true';

if (shouldLoadAhrefsAnalytics) {
  const ahrefsScript = document.createElement('script');
  ahrefsScript.src = 'https://analytics.ahrefs.com/analytics.js';
  ahrefsScript.setAttribute('data-key', 'Cgcyd3+vQlF/c0HppgC6GQ');
  ahrefsScript.async = true;
  document.head.appendChild(ahrefsScript);
}

if (!redirectingToOAuthCallback) {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(preloadReloadGuardKey);
  }
  createRoot(document.getElementById("root")!).render(<App />);
}
